import {useEffect} from 'react';
import {atom, useRecoilState} from 'recoil';
import {BoxLocalStorageData} from './boxLocalStorageTypes';

const boxLocalStorageDataAtom = atom<BoxLocalStorageData>({
  key: 'boxLocalStorageDataAtom',
  default: {
    likedAnswerIds: [],
    viewNewQuestionsAt: '',
  },
});

export function useBoxLocalStorage() {
  const [storedValue, setStoredValue] = useRecoilState(boxLocalStorageDataAtom);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const item = window.localStorage.getItem('box');
      if (!item) {
        return;
      }

      const parsedItem = BoxLocalStorageData.safeParse(JSON.parse(item));
      if (!parsedItem.success) {
        return;
      }

      setStoredValue(parsedItem.data);
    } catch {
      alert('エラーが発生しました');
    }
  }, [setStoredValue]);

  const updateStoredValue = (data: BoxLocalStorageData) => {
    if (typeof window !== 'undefined') {
      try {
        window.localStorage.setItem(
          'box',
          JSON.stringify({...storedValue, ...data}),
        );
      } catch {
        alert('エラーが発生しました');
        return;
      }
    }

    setStoredValue({...storedValue, ...data});
  };

  return {
    storedValue,
    updateStoredValue,
  } as const;
}
